import React from "react";
import "../css/banner.css";

const Banner = ({ imagePath = "", content = null, alignment = "left" }) => {
  return (
    <section
      className={`banner-container ${alignment}`}
      style={{ backgroundImage: `url(${imagePath})` }}
    >
        <div className="quote-container">
          {content}
          <span className="quote-author"> – HH Bhakti Tirtha Swami -</span>
        </div>
    </section>
  );
};

export default Banner;
